import React, { Component } from "react";
import { FaDownload } from "react-icons/fa";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "react-select";
import { getdistrictlist } from "store/participantdistrict/actions";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import logo from "../../assets/images/LogoNeqas.jpg";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Table,
  Button,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import Breadcrumbs from "components/Common/Breadcrumb";
import { getparticipantperformancereport } from "store/Payment/actions";
import { getAnalytelist } from "store/databaseofunits/actions";
import { getSchemelist } from "store/scheme/actions";
import { getPurchasedSchemelist } from "store/scheme/actions";
import "assets/scss/table.scss";
import { Formik, Field, Form, ErrorMessage } from "formik";
class ParticipantPerformance extends Component {
  getStatusCode = (schemeType, result) => {
    if (schemeType === "qualitative") {
      const yourResult = result?.qualitative_result_type || "";
      if (yourResult?.toString().toLowerCase() === "not submitted") {
        return { code: "NS", fullName: "Not Submitted", color: "#000" };
      }
      switch (result.score) {
        case 5:
          return { code: "A", fullName: "Accepted", color: "#0f6723ff" };
        case 0:
          return { code: "R", fullName: "Rejected", color: "#970d1bff" };
        default:
          return { code: "NS", fullName: "Not Submitted", color: "#000" };
      }
    } else {
      // Quantitative
      const evalText = (result.evaluation || "Not Submitted").toLowerCase();
      let color = "#000";
      let fullName = "Not Submitted";
      let code = "NS";

      switch (evalText) {
        case "acceptable":
        case "accepted":
          color = "#0f6723ff";
          fullName = "Accepted";
          code = "A";
          break;
        case "rejected":
          color = "#970d1bff";
          fullName = "Rejected";
          code = "R";
          break;
        case "warning":
          color = "#004085";
          fullName = "Warning";
          code = "W";
          break;
        case "submitted":
          color = "#000";
          fullName = "Submitted";
          code = "S";
          break;
        case "not submitted":
        case "":
          color = "#000";
          fullName = "Not Submitted";
          code = "NS";
          break;
        default:
          color = "#000";
          fullName = result.evaluation || result.result || "Not Submitted";
          code = evalText || "NS";
      }

      return { code, fullName, color };
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      showDetailModal: false,
      modalData: [], // Detailed results to display
      modalTitle: "", // Optional: show analyte & lab name
      nameFilter: "",
      idFilter: "",
      districtFilter: "",
      statusFilter: "", // ✅ add this
      resultFilter: "",
      roundNameFilter: "",
      unitFilter: "",
      methodFilter: "",
      instrumentFilter: "",
      reagentFilter: "",
      participantFilter: "",
      schemeFilter: "",
      schemeModalOpen: false,
      amountFilter: "",
      discountFilter: "",
      GetParticipantEvaluation: [],
      showIdentificationTable: false,
      identificationTableRows: [],
      PurchasedScheme: [],
      tableKey: 0,
      feedbackMessage: "",
      totalParticipants: "",
      participantsWithResults: "",
      errorMessage: "",
      editModalOpen: false,
      selectedRow: null,
      analytes: [], // ✅ initialize
      schemes: [], // ✅ initialize
      cycles: [], // ✅ initialize
      rounds: [],
      filteredSchemes: [],
      filteredCycles: [],
      filteredRounds: [],
      analyteSummaryMap: {}, // ✅ FIXED LINE
      analyteFilter: "",
      schemeFilter: "",
      cycleFilter: "",
      roundFilter: "", // ✅ initialize
      participantModalOpen: false, // controls modal visibility
      selectedParticipant: "", // title for modal
      participantRows: [], // table data inside modal
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",

      feedbackListColumns: [
        {
          dataField: "analyte_name",
          text: "Analyte",
          sort: true,
          style: { textAlign: "left", paddingLeft: "8px" }, // cells left-aligned
          headerStyle: { textAlign: "center" }, // header centered
        },
      ],
    };
  }
  componentDidMount() {
    const { onGetPurchasedScheme } = this.props;
    const { user_id } = this.state;

    if (user_id) {
      onGetPurchasedScheme(user_id);
    }
  }

  fetchData() {
    const { onGetParticipantPerformance } = this.props;
    const { analyteFilter } = this.state;

    if (analyteFilter) {
      // analyteFilter must be analyte_id, not name
      onGetParticipantPerformance(analyteFilter);
    }
  }
  componentDidUpdate(prevProps) {
    const { GetParticipantEvaluation, PurchasedScheme } = this.props;

    // Update PurchasedScheme in state
    if (prevProps.PurchasedScheme !== PurchasedScheme) {
      this.setState({ PurchasedScheme });
    }

    // When evaluation data changes
    if (GetParticipantEvaluation !== prevProps.GetParticipantEvaluation) {
      const schemeData = GetParticipantEvaluation || {};

      const schemeType = (
        schemeData?.analytetype ||
        schemeData?.analyte_type ||
        "quantitative"
      ).toLowerCase();

      const cycles = schemeData?.cycles || [];
      const isIdentification = schemeType === "identification";

      this.setState({
        schemeType,
        showIdentificationTable: isIdentification,
      });

      /* =========================================================
       BUILD ANALYTES LIST
    ========================================================= */
      const analytesInScheme = isIdentification
        ? Array.from(
            new Set(
              cycles.flatMap((c) =>
                (c.rounds || []).flatMap((r) =>
                  (r.organism_antibiotic_statistics || []).flatMap((s) =>
                    (s.antibiotics || []).map(
                      (ab) => `${s.organism}-${ab.antibiotic}`,
                    ),
                  ),
                ),
              ),
            ),
          ).sort((a, b) => a.localeCompare(b))
        : Array.from(
            new Set(
              cycles.flatMap((c) =>
                (c.rounds || []).flatMap((r) =>
                  (r.results || []).map((res) => res.analyte_name),
                ),
              ),
            ),
          ).sort((a, b) => a.localeCompare(b));

      /* =========================================================
       ASSIGN CLEAN ROUND NAMES
    ========================================================= */
      const roundMap = new Map();
      let roundCounter = 1;

      cycles.forEach((cycle) => {
        (cycle.rounds || []).forEach((r) => {
          if (r.status !== "Report Available") return;

          const id = r.round_id || r.id;
          if (id && !roundMap.has(id)) {
            roundMap.set(id, `Round ${roundCounter}`);
            roundCounter++;
          }
        });
      });

      const allRounds = Array.from(roundMap.values());

      /* =========================================================
       BUILD PIVOT TABLE
    ========================================================= */
      const tableRows = analytesInScheme.map((name) => {
        const row = {
          analyte_name: name,
          lab_name:
            PurchasedScheme?.lab_name || schemeData.lab?.lab_ || "NHS NEQAS",
          detailed_results: {},
        };

        allRounds.forEach((round) => {
          row[round] = isIdentification
            ? "NS"
            : schemeType === "qualitative"
            ? "NS"
            : "Not Submitted";

          row.detailed_results[round] = [];
        });

        return row;
      });

      /* =========================================================
       FILL RESULTS (✅ SAFE INITIALIZATION FIX APPLIED HERE)
    ========================================================= */
      cycles.forEach((cycle) => {
        (cycle.rounds || []).forEach((r) => {
          const roundName = roundMap.get(r.round_id || r.id) || "No Round";

          if (isIdentification) {
            (r.organism_antibiotic_statistics || []).forEach((stat) => {
              (stat.antibiotics || []).forEach((ab) => {
                const analyteName = `${stat.organism}-${ab.antibiotic}`;
                const row = tableRows.find(
                  (t) => t.analyte_name === analyteName,
                );
                if (!row) return;

                // ✅ ENSURE ARRAY EXISTS
                if (!Array.isArray(row.detailed_results[roundName])) {
                  row.detailed_results[roundName] = [];
                }

                row[roundName] =
                  ab.submitted === "NS" || !ab.submitted
                    ? "NS"
                    : ab.submitted === ab.expected
                    ? "A"
                    : "R";

                row.detailed_results[roundName].push(ab);
              });
            });
          } else {
            (r.results || []).forEach((result) => {
              const analyteName = result.analyte_name;
              const row = tableRows.find((t) => t.analyte_name === analyteName);
              if (!row) return;

              // ✅ ENSURE ARRAY EXISTS
              if (!Array.isArray(row.detailed_results[roundName])) {
                row.detailed_results[roundName] = [];
              }

              const statusObj = this.getStatusCode(schemeType, result);
              row[roundName] = statusObj.code;
              row.detailed_results[roundName].push(result);
            });
          }

          // ===============================
          // FILL MISSING RESULTS (SAFE)
          // ===============================
          analytesInScheme.forEach((analyteName) => {
            const row = tableRows.find((t) => t.analyte_name === analyteName);
            if (!row) return;

            // ✅ CRITICAL FIX
            if (!Array.isArray(row.detailed_results[roundName])) {
              row.detailed_results[roundName] = [];
            }

            if (row.detailed_results[roundName].length === 0) {
              row.detailed_results[roundName].push(
                isIdentification
                  ? { expected: "-", submitted: "NS" }
                  : { evaluation: "Not Submitted" },
              );

              row[roundName] = isIdentification ? "NS" : "Not Submitted";
            }
          });
        });
      });

      /* =========================================================
       IDENTIFICATION-SPECIFIC TABLES
    ========================================================= */
      let organismTableRows = [];
      let antibioticTableRows = [];

      if (isIdentification) {
        const organismSet = new Set();
        const antibioticSet = new Set();

        cycles.forEach((cycle) => {
          (cycle.rounds || []).forEach((r) => {
            (r.organism_antibiotic_statistics || []).forEach((stat) => {
              organismSet.add(stat.organism);
              (stat.antibiotics || []).forEach((ab) =>
                antibioticSet.add(ab.antibiotic),
              );
            });
          });
        });

        organismTableRows = Array.from(organismSet).map((org) => {
          const row = { submitted_organism: org, detailed_results: {} };

          allRounds.forEach((roundName) => {
            let statFound = null;

            cycles.forEach((cycle) => {
              (cycle.rounds || []).forEach((r) => {
                if (roundMap.get(r.round_id || r.id) === roundName) {
                  statFound = (r.organism_antibiotic_statistics || []).find(
                    (s) => s.organism === org,
                  );
                }
              });
            });

            row.detailed_results[roundName] = statFound ? [statFound] : [];
          });

          return row;
        });

        antibioticTableRows = Array.from(antibioticSet).map((ab) => {
          const row = { antibiotic_name: ab, detailed_results: {} };

          allRounds.forEach((roundName) => {
            let found = null;

            cycles.forEach((cycle) => {
              (cycle.rounds || []).forEach((r) => {
                if (roundMap.get(r.round_id || r.id) === roundName) {
                  (r.organism_antibiotic_statistics || []).forEach((stat) => {
                    const match = (stat.antibiotics || []).find(
                      (a) => a.antibiotic === ab,
                    );
                    if (match) found = match;
                  });
                }
              });
            });

            row[roundName] = !found
              ? "NS"
              : found.submitted === found.expected
              ? "A"
              : "R";

            row.detailed_results[roundName] = found ? [found] : [];
          });

          return row;
        });
      }

      /* =========================================================
       FINAL STATE
    ========================================================= */
      const filteredCycles = cycles.map((c) => String(c.cycle_no));

      this.setState(
        {
          schemeType,
          analytesInScheme,
          allRounds,
          tableRows,
          allLabsData: tableRows,
          organismTableRows,
          antibioticTableRows,
          filteredCycles,
          reportScheme: schemeData,
          cycleFilter: "",
          roundFilter: "",
        },
        () => {
          this.handleCycleChange({ value: "All" });
        },
      );
    }
  }

  openDetailModal = (
    analyteName,
    detailedResults = [],
    roundName = "-",
    labName = "-",
  ) => {
    const { schemeType } = this.state;

    const participantRows = detailedResults.map((r) => {
      const status = this.getStatusCode(schemeType, r);

      if (schemeType === "quantitative") {
        return {
          Unit: r.unit || r.submitted_unit || "-",
          Instrument: r.instrument || "-",
          Method: r.method || "-",
          Reagent: r.reagents || r.reagent || "-",
          Result: r.result ?? r.result_afterconversion ?? "-",
          RobustMean: r.robust_mean ?? "-",
          ZScore: r.z_score ?? "-",
          Status: status.code, // short code for table if needed
          FullStatus: status.fullName, // full name for modal
          StatusColor: status.color,
        };
      } else {
        return {
          Instrument: r.instrument || "-",
          Method: r.method || "-",
          Reagent: r.reagent || r.reagents || "-",
          YourResult: r.qualitative_result_type || "-",
          ExpectedResult: r.expected_result_type || "-",
          Score: r.score ?? "-",
          Status: status.code,
          FullStatus: status.fullName,
          StatusColor: status.color,
        };
      }
    });

    this.setState({
      participantModalOpen: true,
      selectedParticipant: analyteName,
      participantRows,
      selectedRound: roundName,
      selectedLab: labName,
    });
  };

  handleSchemeChange = (selected) => {
    const selectedSchemeId = selected?.value;
    const { user_id } = this.state;

    // Update schemeFilter and reset cycle/round filters
    this.setState(
      {
        schemeFilter: selectedSchemeId,
        cycleFilter: "",
        roundFilter: "",
        tableRows: [], // clear table until new data loads
        allLabsData: [],
        filteredCycles: [],
        analytesInScheme: [],
        organismTableRows: [], // ✅ reset organism table
        antibioticTableRows: [], // ✅ reset antibiotic table
      },
      () => {
        if (selectedSchemeId) {
          this.props.onGetParticipantPerformance(
            Number(selectedSchemeId),
            Number(user_id),
          );
        }
      },
    );
  };

  handleCycleChange = (selected) => {
    const selectedCycle =
      !selected || selected.value === "All" ? "" : String(selected.value);

    const { reportScheme, analytesInScheme } = this.state;
    if (!reportScheme) return;

    // =========================
    // SCHEME TYPE
    // =========================
    const schemeType = (
      reportScheme.analytetype ||
      reportScheme.analyte_type ||
      "quantitative"
    ).toLowerCase();

    // =========================
    // NORMALIZE helper
    // =========================
    const normalize = (v) => String(v || "").replace(/^0+/, "");

    const cycles = reportScheme.cycles || [];
    const allRoundsFromAPI = reportScheme.rounds || [];

    // =========================
    // FILTER ROUNDS (Report Available ONLY)
    // =========================
    let filteredRounds = cycles.flatMap((c) =>
      !selectedCycle || normalize(c.cycle_no) === normalize(selectedCycle)
        ? (c.rounds || []).filter(
            (r) => (r.status || "").toLowerCase().trim() === "report available",
          )
        : [],
    );

    // ---------- fallback if cycles[].rounds empty ----------
    if (filteredRounds.length === 0 && allRoundsFromAPI.length > 0) {
      filteredRounds = allRoundsFromAPI.filter(
        (r) =>
          (r.status || "").toLowerCase().trim() === "report available" &&
          (!selectedCycle ||
            normalize(r.cycle_no) === normalize(selectedCycle)),
      );
    }

    // =========================
    // BUILD ROUND MAP (🔥 FIXED)
    // ONLY FROM filteredRounds
    // =========================
    const roundMap = new Map();
    let counter = 1;

    filteredRounds.forEach((r) => {
      const id = r.round_id || r.id;
      if (id && !roundMap.has(id)) {
        roundMap.set(id, `Round ${counter}`);
        counter++;
      }
    });

    const allRounds = Array.from(roundMap.values());

    // =========================
    // NO ROUNDS FOUND
    // =========================
    if (filteredRounds.length === 0 && schemeType !== "identification") {
      const tableRows = (analytesInScheme || []).map((analyte) => ({
        analyte_name: analyte,
        "No Rounds available": "-",
        detailed_results: { "No Rounds available": [] },
      }));

      this.setState({
        cycleFilter: selectedCycle,
        roundFilter: "",
        filteredRounds: [],
        tableRows,
        allRounds: ["No Rounds available"],
        organismTableRows: [],
        antibioticTableRows: [],
      });
      return;
    }

    // =========================
    // IDENTIFICATION SCHEME
    // =========================
    if (schemeType === "identification") {
      const organismSet = new Set();
      const antibioticSet = new Set();

      filteredRounds.forEach((r) => {
        (r.organism_antibiotic_statistics || []).forEach((stat) => {
          organismSet.add(stat.organism);
          (stat.antibiotics || []).forEach((ab) =>
            antibioticSet.add(ab.antibiotic),
          );
        });
      });

      const organismTableRows = Array.from(organismSet).map((org) => ({
        submitted_organism: org,
        detailed_results: {},
      }));

      const antibioticTableRows = Array.from(antibioticSet).map((ab) => ({
        antibiotic_name: ab,
        detailed_results: {},
      }));

      // ----- ORGANISM TABLE -----
      organismTableRows.forEach((row) => {
        allRounds.forEach((roundName) => {
          const roundData = filteredRounds.find(
            (r) => roundMap.get(r.round_id || r.id) === roundName,
          );

          const stat = roundData
            ? (roundData.organism_antibiotic_statistics || []).find(
                (s) => s.organism === row.submitted_organism,
              )
            : null;

          row.detailed_results[roundName] = stat ? [stat] : [];
        });
      });

      // ----- ANTIBIOTIC TABLE -----
      antibioticTableRows.forEach((row) => {
        allRounds.forEach((roundName) => {
          const roundData = filteredRounds.find(
            (r) => roundMap.get(r.round_id || r.id) === roundName,
          );

          let status = "NS";

          if (roundData) {
            (roundData.organism_antibiotic_statistics || []).forEach((stat) => {
              (stat.antibiotics || []).forEach((ab) => {
                if (ab.antibiotic === row.antibiotic_name) {
                  const expected = (ab.expected || "").toUpperCase();
                  const submitted = (ab.submitted || "").toUpperCase();

                  if (!submitted || submitted === "NS") status = "NS";
                  else if (submitted === expected) status = "A";
                  else status = "R";
                }
              });
            });
          }

          row[roundName] = status;
        });
      });

      this.setState({
        cycleFilter: selectedCycle,
        roundFilter: "",
        filteredRounds,
        allRounds,
        organismTableRows,
        antibioticTableRows,
        tableRows: [],
      });

      return;
    }

    // =========================
    // QUANTITATIVE / QUALITATIVE
    // =========================
    const tableRows = (analytesInScheme || []).map((analyte) => {
      const row = { analyte_name: analyte, detailed_results: {} };

      allRounds.forEach((roundName) => {
        row[roundName] = "Not Submitted";
        row.detailed_results[roundName] = [];
      });

      filteredRounds.forEach((round) => {
        const roundName = roundMap.get(round.round_id || round.id);
        if (!roundName) return;

        (round.results || []).forEach((res) => {
          if (res.analyte_name === analyte) {
            row[roundName] =
              res.evaluation || res.qualitative_result_type || "Not Submitted";
            row.detailed_results[roundName].push(res);
          }
        });
      });

      return row;
    });

    this.setState({
      cycleFilter: selectedCycle,
      roundFilter: "",
      filteredRounds,
      tableRows,
      allRounds,
      organismTableRows: [],
      antibioticTableRows: [],
    });
  };

  filterData = () => {
    const { tableRows, statusFilter, schemeType } = this.state;

    if (!Array.isArray(tableRows)) return [];
    if (!statusFilter || statusFilter.toLowerCase() === "all") return tableRows;

    const normalize = (val) => (val || "").toString().toLowerCase().trim();
    const normalizedFilter = normalize(statusFilter);

    return tableRows.filter((row) => {
      const allRoundKeys = Object.keys(row.detailed_results || {});

      return allRoundKeys.some((round) => {
        const results = Array.isArray(row.detailed_results[round])
          ? row.detailed_results[round]
          : [];

        // ✅ Handle "not submitted" — match rounds where value is NS/Not Submitted
        if (normalizedFilter === "not submitted") {
          const roundValue = normalize(row[round]);
          return (
            roundValue === "ns" ||
            roundValue === "not submitted" ||
            results.length === 0
          );
        }

        if (results.length === 0) return false;

        return results.some((res) => {
          if (schemeType === "identification") {
            // ✅ Use submitted/expected fields for identification
            const submitted = normalize(res?.submitted);
            const expected = normalize(res?.expected);

            if (normalizedFilter === "accepted") {
              return submitted && submitted !== "ns" && submitted === expected;
            }
            if (normalizedFilter === "rejected") {
              return submitted && submitted !== "ns" && submitted !== expected;
            }
            return false;
          } else {
            // Quantitative / Qualitative
            const evaluation = normalize(res?.evaluation);
            const qualitative = normalize(res?.qualitative_result_type);
            const combined = evaluation || qualitative;

            if (normalizedFilter === "accepted") {
              return combined === "accepted" || combined === "acceptable";
            }
            if (normalizedFilter === "rejected") {
              return combined === "rejected";
            }
            if (normalizedFilter === "warning") {
              return combined === "warning";
            }
            return false;
          }
        });
      });
    });
  };

  preparePivotedTableData = () => {
    const { GetParticipantEvaluation } = this.props;
    if (!GetParticipantEvaluation || !GetParticipantEvaluation.scheme)
      return { pivotedRows: [], allRounds: [] };

    const schemeData = GetParticipantEvaluation.scheme;
    const cycles = Array.isArray(schemeData.cycles) ? schemeData.cycles : [];
    const isIdentification =
      (
        schemeData.analytetype ||
        schemeData.analyte_type ||
        ""
      ).toLowerCase() === "identification";

    const analytesInScheme = isIdentification
      ? Array.from(
          new Set(
            cycles.flatMap((c) =>
              (c.rounds || []).flatMap((r) =>
                (r.organism_antibiotic_statistics || []).map(
                  (s) => `${s.organism}-${s.antibiotic}`,
                ),
              ),
            ),
          ),
        ).sort((a, b) => a.localeCompare(b))
      : Array.from(
          new Set(
            cycles.flatMap((c) =>
              Array.isArray(c.analyte_summary)
                ? c.analyte_summary.map((a) => a.analyte_name)
                : [],
            ),
          ),
        ).sort((a, b) => a.localeCompare(b));

    const allRoundsSet = new Set();
    cycles.forEach((cycle) => {
      (Array.isArray(cycle.analyte_summary)
        ? cycle.analyte_summary
        : []
      ).forEach((entry) => {
        const detailedResultsArray = Array.isArray(entry.detailed_results)
          ? entry.detailed_results
          : Object.values(entry.detailed_results || {});
        detailedResultsArray.forEach((r) => {
          const roundName =
            r?.round_name || `Round-${r?.round_number || r?.round_id || "-"}`;
          if (roundName) allRoundsSet.add(roundName);
        });
      });
      if (isIdentification) {
        (cycle.rounds || []).forEach((r) => {
          const roundName =
            r?.round_name || `Round-${r?.round_number || r?.round_id || "-"}`;
          if (roundName) allRoundsSet.add(roundName);
        });
      }
    });

    const allRounds = Array.from(allRoundsSet).sort(
      (a, b) =>
        (parseInt(a.replace(/\D/g, ""), 10) || 0) -
        (parseInt(b.replace(/\D/g, ""), 10) || 0),
    );

    const pivotedRows = analytesInScheme.map((analyteName) => {
      const row = { analyte_name: analyteName, detailed_results: {} };

      cycles.forEach((cycle) => {
        (Array.isArray(cycle.rounds) ? cycle.rounds : []).forEach((r) => {
          const roundName =
            r?.round_name || `Round-${r?.round_number || r?.round_id || "-"}`;
          if (!row.detailed_results[roundName])
            row.detailed_results[roundName] = [];

          if (isIdentification) {
            (r.organism_antibiotic_statistics || []).forEach((stat) => {
              const statName = `${stat.organism}-${stat.antibiotic}`;
              if (statName === analyteName) {
                row[roundName] = stat.submitted?.result || "NS";
                row.detailed_results[roundName].push(stat.submitted || {});
              }
            });
          } else {
            (Array.isArray(r.results) ? r.results : []).forEach((result) => {
              if (result?.analyte_name === analyteName) {
                row[roundName] =
                  result.evaluation || result.qualitative_result_type || "-";
                row.detailed_results[roundName].push(result);
              }
            });
          }

          if (row.detailed_results[roundName].length === 0) {
            row[roundName] = isIdentification ? "NS" : "Not Submitted";
            row.detailed_results[roundName] = [];
          }
        });
      });

      return row;
    });

    return { pivotedRows, allRounds };
  };

  handleFilterChange = (filterName, e) => {
    const value = e.target.value;
    this.setState({
      [filterName]: value,
      currentPage: 1, // ✅ reset pagination to first page when filter changes
    });
  };
  generateRoundColumns = () => {
    const { allRounds, schemeType } = this.state;

    return (allRounds || []).map((round) => ({
      dataField: round,
      text: round,
      sort: true,
      align: "center",
      headerAlign: "center",
      formatter: (cell, row) => {
        const detailedRows = row.detailed_results?.[round] || [];

        // Take the first result object for this round, fallback if missing
        const resultObj = detailedRows[0] || {
          qualitative_result_type: cell,
          score: 0,
          evaluation: cell,
        };

        // Get status code and color using your existing function
        const status = this.getStatusCode(schemeType, resultObj);

        return (
          <span
            style={{
              color: status.color,
              fontWeight: "bold",
              cursor: "pointer",
            }}
            title={status.code}
            onClick={() => {
              this.openDetailModal(row.analyte_name, detailedRows, round);
            }}
          >
            {status.code}
          </span>
        );
      },
    }));
  };

  downloadPDF = () => {
    console.log("------ PDF GENERATION STARTED ------");

    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const footerHeight = 15;

    const { tableRows, allRounds, PurchasedScheme, schemeFilter, cycleFilter } =
      this.state;

    if (!tableRows || tableRows.length === 0) {
      alert("No data to export");
      return;
    }

    // ---------- SELECTED SCHEME & CYCLE ----------
    const selectedScheme =
      PurchasedScheme?.find(
        (s) => Number(s.scheme_id) === Number(schemeFilter),
      ) || tableRows[0];

    const labName = selectedScheme?.lab_name || "NHS NEQAS";
    const schemeName = selectedScheme?.scheme_name || "-";
    const cycleStart = selectedScheme?.start_date || "-";
    const cycleEnd = selectedScheme?.end_date || "-";
    const selectedCycle = cycleFilter || "All";

    const formatDate = (dateStr) => {
      if (!dateStr || dateStr === "-") return "-";
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const d = new Date(dateStr);
      return `${String(d.getDate()).padStart(2, "0")}-${
        months[d.getMonth()]
      }-${String(d.getFullYear()).slice(-2)}`;
    };

    const startDateFormatted = formatDate(cycleStart);
    const endDateFormatted = formatDate(cycleEnd);

    // ---------- CURRENT DATE & TIME ----------
    const now = new Date();
    const downloadDateTime = `${String(now.getDate()).padStart(
      2,
      "0",
    )}-${String(now.getMonth() + 1).padStart(
      2,
      "0",
    )}-${now.getFullYear()} ${String(now.getHours()).padStart(2, "0")}:${String(
      now.getMinutes(),
    ).padStart(2, "0")}`;

    const noteText =
      "NOTE: This report summarizes the performance for each analyte across all rounds. " +
      "A = Accepted, W = Warning, R = Rejected, S = Submitted, NS = Not Submitted. ";

    // ---------- BUILD TABLE DATA ----------
    const tableColumn = ["Analyte", ...allRounds];

    const tableRowsPDF = tableRows.map((row) => {
      const rowData = [row.analyte_name];
      allRounds.forEach((round) => {
        const detailed = row.detailed_results?.[round] || [];
        let code = "NS";

        if (detailed.length > 0) {
          const evalText =
            detailed[0].evaluation || detailed[0].qualitative_result_type || "";
          switch (evalText.toLowerCase()) {
            case "acceptable":
            case "accepted":
              code = "A";
              break;
            case "warning":
              code = "W";
              break;
            case "rejected":
              code = "R";
              break;
            case "submitted":
              code = "S";
              break;
            case "not submitted":
            case "":
              code = "NS";
              break;
            default:
              code = evalText;
          }
        }

        rowData.push(code);
      });
      return rowData;
    });

    // ---------- LOGO ----------
    try {
      doc.addImage(logo, "JPEG", (pageWidth - 40) / 2, 10, 40, 15);
    } catch (e) {
      console.log("Logo Error:", e);
    }

    // ---------- PRINT DATE/TIME TOP-RIGHT ----------
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.text(`Downloaded: ${downloadDateTime}`, pageWidth - 15, 15, {
      align: "right",
    });

    // ---------- LAB NAME ----------
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.setTextColor(0, 0, 0);
    doc.text(labName, pageWidth / 2, 35, { align: "center" });

    // ---------- SCHEME DETAILS (VERTICAL LAYOUT) ----------
    let detailsY = 45; // starting Y position for fields
    const labelX = 15; // X position for labels
    const valueX = 50; // X position for values

    const fields = [
      { label: "Scheme Name:", value: schemeName },
      { label: "Cycle:", value: selectedCycle },
      { label: "Start Date:", value: startDateFormatted },
      { label: "End Date:", value: endDateFormatted },
    ];

    fields.forEach((f) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text(f.label, labelX, detailsY);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.text(f.value, valueX, detailsY);

      detailsY += 6; // move down for next field
    });

    // ---------- NOTE BELOW SCHEME DETAILS ----------
    const noteY = detailsY + 5; // small spacing after last field
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("NOTE:", 15, noteY);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    const wrappedNote = doc.splitTextToSize(noteText, pageWidth - 30);
    doc.text(wrappedNote, 15, noteY + 6);

    // ---------- TABLE STARTS BELOW NOTE ----------
    const tableStartY = noteY + 6 + wrappedNote.length * 4; // leave space after note

    autoTable(doc, {
      head: [tableColumn],
      body: tableRowsPDF,
      startY: tableStartY,
      margin: { bottom: footerHeight },
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 2,
        valign: "middle",
        halign: "center",
      },
      headStyles: { fillColor: [135, 206, 235], textColor: [0, 0, 0] },
      columnStyles: { 0: { halign: "left" } },
      didDrawPage: function (data) {
        const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
        doc.setFontSize(7);
        doc.text(`Page ${pageNumber}`, pageWidth / 2, pageHeight - 8, {
          align: "center",
        });
      },
    });

    // ---------- SAVE ----------
    doc.save("Participant_Report.pdf");
  };

  render() {
    const { GetParticipantEvaluation } = this.state;
    const { onGetAnalyte, onGetPurchasedScheme } = this.props;
    const defaultSorted = [{ dataField: "id", order: "desc" }];

    const filteredData = this.filterData() || [];

    const totalParticipants = filteredData.length;
    const participantsWithResults = filteredData.filter(
      (lab) => lab.result_value !== null && lab.result_value !== undefined,
    ).length;

    const pageOptions = {
      sizePerPage: 50,
      totalSize: filteredData.length,
      custom: true,
      page: this.state.currentPage || 1,
      onPageChange: (page) => this.setState({ currentPage: page }),
    };

    // Graceful fallback if no rounds exist
    const displayRounds =
      this.state.allRounds && this.state.allRounds.length > 0
        ? this.state.allRounds
        : ["No Rounds available"];

    // Performance table columns
    const roundColumns = displayRounds
      .filter((r) => typeof r === "string")
      .map((round) => ({
        dataField: round,
        text: round,
        sort: true,
        style: { textAlign: "center" },
        headerStyle: { textAlign: "center" },
        formatter: (cell, row) => {
          const detailed = row.detailed_results?.[round] || [];
          const resultObj = detailed[0] || {
            qualitative_result_type: cell,
            evaluation: cell,
          };
          const status = this.getStatusCode(this.state.schemeType, resultObj);

          return (
            <span
              style={{
                color: status.color,
                fontWeight: "bold",
                cursor: detailed.length > 0 ? "pointer" : "default",
              }}
              title={status.fullName}
              onClick={() =>
                detailed.length > 0 &&
                this.openDetailModal(row.analyte_name, detailed, round)
              }
            >
              {status.code}
            </span>
          );
        },
      }));

    const allColumns = [
      {
        dataField: "analyte_name",
        text: "Analyte",
        sort: true,
        style: { textAlign: "left", paddingLeft: "8px" },
        headerStyle: { textAlign: "center" },
      },
      ...roundColumns,
    ].filter(Boolean);

    // Identification tables rounds fallback
    const organismRounds = displayRounds;
    const antibioticRounds = displayRounds;

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Analyte Report | NHS NEQAS</title>
          </MetaTags>

          <Container fluid>
            <Breadcrumbs title="Labs" breadcrumbItem="PERFORMANCE REPORT " />
            <Row className="mb-3">
              <Col lg="8">
                <div style={{ fontSize: "0.9rem", paddingLeft: "15px" }}>
                  <strong>Note:</strong> The table below displays participant
                  performance statuses for each round:
                  <ul style={{ marginTop: "5px", paddingLeft: "20px" }}>
                    <li>
                      <strong>
                        <span style={{ color: "#0f6723ff" }}>A:</span>
                      </strong>{" "}
                      Acceptable – Result meets the required quality standards.
                    </li>
                    <li>
                      <strong>
                        <span style={{ color: "#004085" }}>W:</span>
                      </strong>{" "}
                      Warning – Result is borderline and may require attention.
                    </li>
                    <li>
                      <strong>
                        <span style={{ color: "#970d1bff" }}>R:</span>
                      </strong>{" "}
                      Rejected – Result does not meet quality standards.
                    </li>
                    <li>
                      <strong>
                        <span style={{ color: "#000000" }}>NS:</span>
                      </strong>{" "}
                      Not Submitted – Participant did not submit a result for
                      this round.
                    </li>
                  </ul>
                </div>
              </Col>
              <Col lg="2"></Col>
              <Col lg="2" className="text-end">
                <Button color="primary" onClick={this.downloadPDF}>
                  <FaDownload /> Download PDF
                </Button>
              </Col>
            </Row>

            {/* Filters */}
            <Row className="mb-3">
              <Col md={4}>
                <Label>Scheme</Label>
                <Select
                  options={
                    Array.isArray(this.props.PurchasedScheme)
                      ? this.props.PurchasedScheme.map((s) => ({
                          value: Number(s.scheme_id),
                          label: s.scheme_name,
                        }))
                      : []
                  }
                  onChange={(selected) => {
                    const selectedSchemeId = selected ? selected.value : "";
                    this.setState(
                      {
                        schemeFilter: selectedSchemeId,
                        cycleFilter: "",
                        roundFilter: "",
                        statusFilter: "",
                        tableRows: [],
                        allLabsData: [],
                        filteredCycles: [],
                        analytesInScheme: [],
                        participantRows: [],
                        selectedParticipant: "",
                        participantModalOpen: false,
                        schemeType: "",
                      },
                      () => {
                        if (selectedSchemeId) {
                          this.props.onGetParticipantPerformance(
                            Number(selectedSchemeId),
                            Number(this.state.user_id),
                          );
                        }
                      },
                    );
                  }}
                  value={
                    this.state.schemeFilter
                      ? (() => {
                          const selected = this.props.PurchasedScheme.find(
                            (s) =>
                              Number(s.scheme_id) === this.state.schemeFilter,
                          );
                          return selected
                            ? {
                                value: Number(selected.scheme_id),
                                label: selected.scheme_name,
                              }
                            : null;
                        })()
                      : null
                  }
                  placeholder="Select Scheme"
                  isClearable
                />
              </Col>

              <Col md={4}>
                <Label>Cycle</Label>
                <Select
                  options={[
                    { value: "All", label: "All Cycles" },
                    ...(this.state.filteredCycles || []).map((cycle) => ({
                      value: String(cycle),
                      label: `Cycle ${cycle}`,
                    })),
                  ]}
                  onChange={this.handleCycleChange}
                  value={
                    this.state.cycleFilter
                      ? {
                          value: this.state.cycleFilter,
                          label: `Cycle ${this.state.cycleFilter}`,
                        }
                      : { value: "All", label: "All Cycles" }
                  }
                />
              </Col>

              <Col md={3}>
                <Label>Status</Label>
                <Select
                  options={[
                    { value: "All", label: "All" },
                    { value: "accepted", label: "Accepted" },
                    { value: "warning", label: "Warning" },
                    { value: "rejected", label: "Rejected" },
                    { value: "not submitted", label: "Not Submitted" },
                  ]}
                  onChange={(selected) => {
                    const value =
                      selected?.value === "All"
                        ? ""
                        : selected?.value.toLowerCase();
                    this.setState({ statusFilter: value });
                  }}
                  value={
                    this.state.statusFilter
                      ? {
                          value: this.state.statusFilter,
                          label:
                            this.state.statusFilter === "not_submitted"
                              ? "Not Submitted"
                              : this.state.statusFilter
                                  .charAt(0)
                                  .toUpperCase() +
                                this.state.statusFilter.slice(1),
                        }
                      : { value: "All", label: "All" }
                  }
                  placeholder="Select Status"
                  isClearable
                />
              </Col>
            </Row>

            <Row className="justify-content-center align-item-center">
              <Col lg="10">
                {this.state.showIdentificationTable ? (
                  <Card>
                    <CardBody>
                      {/* <h5>Identification Scheme Results</h5> */}
                      {/* Organism Table */}
                      <Table bordered striped responsive>
                        <thead>
                          <tr>
                            <th
                              style={{
                                textAlign: "center",
                                width: "200px",
                                backgroundColor: "#b7dbf5",
                                color: "#004a99",
                              }}
                            >
                              Organism Name
                            </th>
                            {organismRounds.map((r, i) => (
                              <th
                                key={i}
                                style={{
                                  textAlign: "center",
                                  backgroundColor: "#b7dbf5",
                                  color: "#004a99",
                                }}
                              >
                                {r}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.organismTableRows?.map((row, idx) => (
                            <tr key={idx}>
                              <td
                                style={{
                                  textAlign: "left",
                                  paddingLeft: "8px",
                                  width: "200px",
                                }}
                              >
                                {row.submitted_organism}
                              </td>
                              {organismRounds.map((roundName, i) => {
                                const detailed =
                                  row.detailed_results?.[roundName] || [];
                                const stat = detailed[0] || {};
                                const submittedOrganism = (
                                  stat.submitted_organism || ""
                                ).trim();

                                let displayText = "NS";
                                let hoverText = "Not Submitted";
                                let color = "#000";

                                if (
                                  !submittedOrganism ||
                                  submittedOrganism === "-"
                                ) {
                                  displayText = "NS";
                                  hoverText = "Not Submitted";
                                  color = "#000";
                                } else if (
                                  submittedOrganism.toLowerCase() !==
                                  (stat.organism || "").toLowerCase()
                                ) {
                                  displayText = "R";
                                  hoverText = "Rejected";
                                  color = "#970d1bff";
                                } else {
                                  displayText = "A";
                                  hoverText = "Accepted";
                                  color = "#0f6723ff";
                                }

                                return (
                                  <td
                                    key={i}
                                    style={{
                                      color,
                                      fontWeight: "bold",
                                      textAlign: "center",
                                      paddingLeft: "8px",
                                    }}
                                    title={hoverText}
                                  >
                                    {displayText}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      {/* Antibiotic Table: show only if no row is NS */}
                      {this.state.organismTableRows?.some((row) =>
                        Object.values(row.detailed_results).some((d) => {
                          const stat = d[0] || {};
                          const submitted = (
                            stat.submitted_organism || ""
                          ).trim();
                          return submitted && submitted !== "NS";
                        }),
                      ) && (
                        <>
                          <h6 className="mt-4">Antibiotic</h6>
                          <Table bordered striped responsive>
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    textAlign: "center",
                                    width: "200px",
                                    backgroundColor: "#b7dbf5",
                                    color: "#004a99",
                                  }}
                                >
                                  Antibiotic Name
                                </th>
                                {antibioticRounds.map((r, i) => (
                                  <th
                                    key={i}
                                    style={{
                                      textAlign: "center",
                                      backgroundColor: "#b7dbf5",
                                      color: "#004a99",
                                    }}
                                  >
                                    {r}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.antibioticTableRows?.map(
                                (row, idx) => (
                                  <tr key={idx}>
                                    <td
                                      style={{
                                        textAlign: "left",
                                        paddingLeft: "8px",
                                        width: "200px",
                                      }}
                                    >
                                      {row.antibiotic_name}
                                    </td>
                                    {antibioticRounds.map((roundName, i) => {
                                      const value = row[roundName] || "NS";

                                      let displayText = "NS";
                                      let hoverText = "Not Submitted";
                                      let color = "#000";

                                      switch (value) {
                                        case "A":
                                          displayText = "A";
                                          hoverText = "Accepted";
                                          color = "#0f6723ff";
                                          break;
                                        case "R":
                                          displayText = "R";
                                          hoverText = "Rejected";
                                          color = "#970d1bff";
                                          break;
                                        case "NS":
                                        default:
                                          displayText = "NS";
                                          hoverText = "Not Submitted";
                                          color = "#000";
                                      }

                                      return (
                                        <td
                                          key={i}
                                          style={{
                                            color,
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            paddingLeft: "8px",
                                          }}
                                          title={hoverText}
                                        >
                                          {displayText}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                ),
                              )}
                            </tbody>
                          </Table>
                        </>
                      )}
                    </CardBody>
                  </Card>
                ) : (
                  <Card>
                    <CardBody>
                      <PaginationProvider
                        key={`tbl-${this.state.analyteFilter || "none"}-${
                          this.state.schemeFilter || "none"
                        }-${this.state.cycleFilter || "none"}-${
                          this.state.roundFilter || "none"
                        }-${this.state.statusFilter || "none"}`}
                        pagination={paginationFactory(pageOptions)}
                        keyField="id"
                        columns={allColumns}
                        data={filteredData}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="id"
                            columns={allColumns}
                            data={filteredData}
                            search
                          >
                            {(toolkitprops) => (
                              <React.Fragment>
                                <BootstrapTable
                                  {...toolkitprops.baseProps}
                                  {...paginationTableProps}
                                  defaultSorted={defaultSorted}
                                  classes={
                                    "table align-middle table-condensed table-hover"
                                  }
                                  bordered={false}
                                  striped
                                  headerWrapperClasses={"table-header-sky-blue"}
                                  responsive
                                  ref={this.node}
                                  filter={filterFactory()}
                                />

                                <Row className="align-items-md-center mt-30">
                                  <Col className="pagination pagination-rounded justify-content-end mb-2">
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </Col>
                                </Row>
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    </CardBody>
                  </Card>
                )}
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ParticipantPerformance.propTypes = {
  GetParticipantEvaluation: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  onGetParticipantPerformance: PropTypes.func,
  AnalyteList: PropTypes.array,
  onGetAnalyte: PropTypes.func,
  match: PropTypes.object,
  PurchasedScheme: PropTypes.array,
  onGetScheme: PropTypes.func,
  onGetPurchasedScheme: PropTypes.func,

  // ✅ Add this
  GetAnalyteEvaluationLab: PropTypes.shape({
    lab: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
};

const mapStateToProps = (state) => {
  console.log("Redux SchemeList state:", state.SchemeList);
  console.log(
    "PurchasedScheme in mapStateToProps:",
    state.SchemeList?.PurchasedScheme,
  );

  return {
    AnalyteList: state.ListUnit?.ListUnit || [],
    GetParticipantEvaluation: state.AddPayment?.GetParticipantEvaluation || {},
    PurchasedScheme: state.SchemeList?.PurchasedScheme || [],
  };
};

const mapDispatchToProps = (dispatch) => ({
  onGetParticipantPerformance: (scheme_id, user_id) =>
    dispatch(getparticipantperformancereport(scheme_id, user_id)),
  onGetScheme: (user_id) => dispatch(getSchemelist(user_id)),
  onGetPurchasedScheme: (user_id) => dispatch(getPurchasedSchemelist(user_id)),
  onGetAnalyte: (id) => dispatch(getAnalytelist(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ParticipantPerformance);
